import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSegmentProfileSelected = createSelector(
    [(store:RootState)=> store.profileDetail.selectedSegmentProfile],
    (selectedProfile)=> selectedProfile
);